<template>
  <div>
    <md-chips
      v-model="selectedPlacesDisplay"
      :class="{ 'md-required': required, 'md-invalid': hasError}"
      class="selected-places md-field"
      @md-click="editPlaces"
      md-static>
      <label>{{ label }}</label>
      <template
        slot="md-chip"
        slot-scope="{ chip }">
        <template v-if="chip === 'edit'">
          <md-icon
            class="edit-chip-icon"
            title="Modifier">mode_edit</md-icon>
        </template>
        <template
          v-else-if="chip.startsWith('count-chip-')">
          {{ chip.substring(11) }}
          <md-icon
            class="edit-chip-icon"
            title="Modifier">mode_edit</md-icon>
        </template>
        <template v-else>
          <span title="Cliquez pour modifier">{{ chip }}</span>
        </template>
      </template>
      <div class="md-helper-text">{{ placesNumber }} lieux sélectionnés</div>
      <span
        v-if="errorMessage"
        class="md-error"
        v-html="errorMessage"/>
    </md-chips>

    <md-dialog
      class='update-modal'
      :md-active="editOn">
      <md-dialog-title>
        Modifier les lieux
      </md-dialog-title>
      <md-dialog-content>
        <places-table
          :selected-places.sync="modalValue"
          :places-type="placesType"
          :show-criterion-alert="true"
          :editable="editable" />
      </md-dialog-content>

      <md-dialog-actions>
        <md-button
          class="md-primary"
          @click="cancelPlacesEdit">Annuler</md-button>
        <md-button
          class="md-primary"
          @click="validatePlacesEdit">Valider</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
import PlacesTable from '@/components/PlacesTable.vue'
export default {
  name: 'UserPlacesInputField',
  mixins: [],
  components: {
    'places-table': PlacesTable
  },
  props: {
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false
    },
    label: {
      type: String,
      required: false,
      default: () => 'Lieux'
    },
    placesType: {
      type: String,
      required: false,
      default: () => 'building'
    },
    editable: {
      type: Boolean,
      required: false,
      default: () => true
    },
    errorMessage: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  data () {
    return {
      localValue: [],
      modalValue: [],
      editOn: false
    }
  },
  async mounted () {
  },
  computed: {
    placesNumber () {
      return this.localValue.length
    },
    selectedPlacesDisplay () {
      let selectedPlacesDisplay = this.localValue.map(place => `${place.name} (${place.identifier})`)
      let slicePlacesDisplay = selectedPlacesDisplay.slice(0, 2)

      const slicePlacesDisplayLength = slicePlacesDisplay.length
      const selectedPlacesDisplayLength = selectedPlacesDisplay.length

      if (slicePlacesDisplayLength < selectedPlacesDisplayLength) {
        const diffCount = selectedPlacesDisplayLength - slicePlacesDisplayLength
        const otherCount = diffCount > 1 ? 'autres' : 'autre'
        return slicePlacesDisplay.concat([`count-chip-et ${diffCount} ${otherCount}`])
      } else {
        return slicePlacesDisplay.concat(['edit'])
      }
    },
    hasError () {
      return this.errorMessage.length > 0
    }
  },
  methods: {
    editPlaces () {
      this.modalValue = this.localValue
      this.editOn = true
    },
    cancelPlacesEdit () {
      this.modalValue = this.localValue
      this.editOn = false
    },
    validatePlacesEdit () {
      this.localValue = this.modalValue
      this.editOn = false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function (value) {
        this.localValue = value
      },
      deep: true
    },
    localValue: {
      handler: function (value) {
        this.$emit('input', value)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
>>> .edit-chip-icon{
  color:black !important;
}
.selected-places, >>> .selected-places .md-chip {
  cursor: pointer;
}

.selected-places{
  margin-bottom: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserPlacesInputField.vue